import axios from "axios";
import { useQuery } from "react-query";

import { IBusLicensesAndPermitsDetails } from "../types";

const apiBaseUrl =
  process.env.REACT_APP_API_BASEURL + "/BusinessLicensePermits";

export interface GetBLPByIdResponse extends Omit<
  IBusLicensesAndPermitsDetails,
  "type" | "licenseStatus" | "renewalStatus"
> {
  type?: number | null;

  busLicensePermitTypeId?: number | null;
  busLicensePermitTypeName?: string | null;

  licenseStatusId?: number | null;
  licenseStatus?: string | null;

  renewalStatusId?: number | null;
  renewalStatus?: string | null;
}

export const getBLPbyId = async (
  recordId: string | number,
): Promise<GetBLPByIdResponse> => {
  const response = await axios.get<GetBLPByIdResponse>(
    `${apiBaseUrl}/${recordId}`,
  );

  return response.data;
};

export const useGetBLPbyId = (
  recordId: string | number | null | undefined,
  enabled: boolean = true,
) => {
  return useQuery<GetBLPByIdResponse>(
    ["GetBLPbyId", recordId],
    () => getBLPbyId(recordId as string | number),
    {
      enabled:
        enabled &&
        recordId !== null &&
        recordId !== undefined &&
        recordId !== "",
      refetchOnWindowFocus: false,
    },
  );
};
